import { render, staticRenderFns } from "./HolidayOther.vue?vue&type=template&id=301cc30c&scoped=true"
import script from "./HolidayOther.vue?vue&type=script&lang=js"
export * from "./HolidayOther.vue?vue&type=script&lang=js"
import style0 from "./HolidayOther.vue?vue&type=style&index=0&id=301cc30c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301cc30c",
  null
  
)

export default component.exports